import type { Dispatch } from 'redux';

import type { IReduxState } from 'types';

import store from './index';

export const { getState } = store;
export const { dispatch }: { dispatch: Dispatch } = store;

export function getSelectors<T>(processor: (state: IReduxState) => T): T {
  return processor(getState());
}
